import React from "react";

export const LegalLayout = ({ title, testid, children }) => (
  <div className="bg-white min-h-[70vh]" data-testid={testid}>
    <div className="max-w-3xl mx-auto px-5 py-16">
      <h1 className="font-display text-4xl sm:text-5xl text-[#1f1a1b]">{title}</h1>
      <p className="text-[14px] text-[#8a8285] mt-3">Last updated: June 2026</p>
      <div className="legal-body mt-8 space-y-4 text-[16px] leading-relaxed text-[#5a5254]
        [&>h2]:font-display [&>h2]:text-xl [&>h2]:text-[#1f1a1b] [&>h2]:mt-8 [&>h2]:mb-1
        [&_a]:text-[#7c2233] [&_a]:underline">
        {children}
      </div>
    </div>
  </div>
);

export default LegalLayout;
